export function isMultiUserPlan(planId?: string) {
  return !!planId?.endsWith("__multi");
}
